<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :form-fields="formFields"
                  :permission="permission" :searchs="searchs" ref="table"/>
  </div>
</template>

<script>
import CommonTable from "../../components/CommonTable/CommonTable";

export default {
  name: "UserRaffleRecord",
  components: {CommonTable},
  data() {
    return {
      searchs: [
        {
          name: 'agentId',
          placeholder: '代理',
          type: 'select',
          selectUrl: '/agent/getAll',
          selectData: [],
        }
      ],
      permission: {
        add: 'userRaffleRecord:add',
        update: 'userRaffleRecord:update',
        delete: 'userRaffleRecord:delete',
        deleteBatch: 'userRaffleRecord:deleteBatch'
      },
      url: {
        get: '/userRaffleRecord/listByCondition',
        add: '/userRaffleRecord/add',
        update: '/userRaffleRecord/update',
        delete: '/userRaffleRecord/delete',
        delete_batch: '/userRaffleRecord/deleteBatch'
      },
      tableColumns: [{
        field: 'id',
        label: 'ID',
        show: true,
        width: '75',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        detail: false,
        width: '',
      },{
        field: 'userName',
        label: '用户',
        show: true,
        detail: true,
        width: '',
      }, {
        field: 'rechargeId',
        label: '充值ID',
        show: true,
        width: '',
      },  {
        field: 'rechargeAmount',
        label: '充值金额',
        show: true,
        width: '',
      }, {
        field: 'startActivityTime',
        label: '活动开始时间',
        show: true,
        width: '',
      }, {
        field: 'endActivityTime',
        label: '活动结束时间',
        show: true,
        width: '',
      },  {
        field: 'minWinningAmount',
        label: '最低奖励',
        show: true,
      }, {
        field: 'maxWinningAmount',
        label: '最高奖励',
        show: true,
      }, {
        field: 'isReceive',
        label: '领取状态',
        show: {
          type: 'tag',
          tags: [{
            key: 0,
            value: '未领取',
            type: 'blue'
          }, {
            key: 1,
            value: '已领取',
            type: 'success'
          }]
        },
      },{
        field: 'winningAmount',
        label: '中奖金额',
        show: true,
      }, {
        field: 'createTime',
        label: '时间',
        show: true,
        width: '',
      }],
      formFields: {
        addTitle: '添加用户活动时详情',
        updateTitle: '修改用户活动时详情',
        labelWidth: '90px',
        model: [{
          field: 'agentId',
          label: '代理：',
          type: 'select',
          placeholder: '请选择代理',
          rules: [{required: true, message: '请选择代理', trigger: 'blur'}],
          selectUrl: '/agent/getAll',
          selectData: [],
          add: true,
          update: true,
          filterable: true,
        }, {
          field: 'userId',
          label: '用户ID：',
          type: 'input',
          placeholder: '用户ID',
          rules:[{
            message: '请输入用户ID', trigger: 'blur', required: true
          }],
          add: true,
          update: true
        }, {
          field: 'rechargeId',
          label: '充值ID：',
          type: 'input',
          placeholder: '充值ID',
          rules:[{
            message: '请输入充值ID', trigger: 'blur', required: true
          }],
          add: true,
          update: true
        },{
          field: 'rechargeAmount',
          label: '充值金额：',
          type: 'input',
          placeholder: '充值ID',
          rules:[{
            message: '请输入充值ID', trigger: 'blur', required: true
          }],
          add: true,
          update: true
        }, {
          field: 'startActivityTime',
          label: '活动开始时间',
          type: 'dateTime',
          placeholder: '活动开始时间',
          rules: [{
            message: '请输入活动开始时间', trigger: 'blur', required: true
          }],
          add: true,
          update: true
        }, {
          field: 'endActivityTime',
          label: '活动结束时间：',
          type: 'dateTime',
          placeholder: '活动结束时间',
          rules: [{
            message: '请输入活动结束时间', trigger: 'blur', required: true
          }],
          add: true,
          update: true
        },{
          field: 'minWinningAmount',
          label: '最低充值：',
          type: 'input',
          placeholder: '最低中奖金额',
          rules:[{
            message: '请输入最低中奖金额', trigger: 'blur', required: true
          }],
          add: true,
          update: true
        }, {
          field: 'maxWinningAmount',
          label: '最高充值：',
          type: 'input',
          placeholder: '最高中奖金额',
          rules:[{
            message: '请输入最高中奖金额', trigger: 'blur', required: true
          }],
          add: true,
          update: true
        }, {
          field: 'isReceive',
          label: '状态类型',
          type: 'select',
          selectData: [{
            id: 0,
            name: '未领取',
          },{
            id: 1,
            name: '已领取',
          }],
          placeholder: '请选择',
          rules: [{
            message: '请选择', trigger: 'blur', required: true
          }],
          add: true,
          update: false,
        },{
          field: 'winningAmount',
          label: '中奖金额：',
          type: 'input',
          placeholder: '中奖金额额',
          rules:[{
            message: '请输入中奖金额', trigger: 'blur', required: true
          }],
          add: true,
          update: true
        }, ]
      }
    }
  },
}
</script>

<style scoped>

</style>
